import { AppIcon, type IconDefinition } from '@/components/ui/app-icon';
import {
  iconAddressBook,
  iconAddressBookSolid,
  iconAlignLeft,
  iconArrowDown,
  iconArrowDownAZ,
  iconArrowDownArrowUp,
  iconArrowLeft,
  iconArrowLeftFromLine,
  iconArrowRight,
  iconArrowRightFromLine,
  iconArrowTrendUp,
  iconArrowUp,
  iconArrowUpRight,
  iconArrowUpRightFromSquare,
  iconArrowUpRightFromSquareSolid,
  iconArrowUpZA,
  iconArrowsLeftRight,
  iconArrowsRotate,
  iconAt,
  iconBadgeCheck,
  iconBadgeCheckSolid,
  iconBagShopping,
  iconBan,
  iconBed,
  iconBedSolid,
  iconBell,
  iconBellSlash,
  iconBellSolid,
  iconBinary,
  iconBolt,
  iconBoltSolid,
  iconBook,
  iconBookOpenLines,
  iconBookOpenLinesSolid,
  iconBookSolid,
  iconBookmark,
  iconBookmarkSolid,
  iconBox,
  iconBriefcase,
  iconBriefcaseSolid,
  iconBrowser,
  iconBrowserSolid,
  iconBuilding,
  iconBuildingColumns,
  iconBuildingSolid,
  iconBuildings,
  iconBuildingsSolid,
  iconBullseye,
  iconBullseyeArrow,
  iconCalendar,
  iconCalendarCheck,
  iconCalendarDays,
  iconCalendarSolid,
  iconChartBar,
  iconChartLine,
  iconChartLineSolid,
  iconChartLineUp,
  iconChartLineUpSolid,
  iconChartSimple,
  iconCheck,
  iconCheckSolid,
  iconChessRook,
  iconChevronDown,
  iconChevronDownSolid,
  iconChevronLeft,
  iconChevronRight,
  iconChevronRightSolid,
  iconChevronUp,
  iconChevronsLeft,
  iconChevronsRight,
  iconChrome,
  iconChurch,
  iconCircle,
  iconCircleArrowUp,
  iconCircleArrowUpSolid,
  iconCircleCheck,
  iconCircleCheckSolid,
  iconCircleChevronDown,
  iconCircleChevronDownSolid,
  iconCircleExclamation,
  iconCircleExclamationSolid,
  iconCircleInfo,
  iconCircleInfoSolid,
  iconCircleQuestion,
  iconCircleQuestionSolid,
  iconCircleSolid,
  iconCircleXmark,
  iconCircleXmarkSolid,
  iconClipboardList,
  iconClipboardListSolid,
  iconClock,
  iconClockRotateLeft,
  iconClockSolid,
  iconCloudArrowUp,
  iconCode,
  iconCodeBranch,
  iconCodeSolid,
  iconCoin,
  iconCoinSolid,
  iconCoins,
  iconCommand,
  iconCopy,
  iconCopySolid,
  iconCreditCard,
  iconCreditCardSolid,
  iconCube,
  iconDatabase,
  iconDatabaseSolid,
  iconDesktop,
  iconDesktopSolid,
  iconDollarSign,
  iconDownLeftAndUpRightToCenter,
  iconDownToLine,
  iconDownload,
  iconDownloadSolid,
  iconEllipsis,
  iconEllipsisSolid,
  iconEllipsisVertical,
  iconEllipsisVerticalSolid,
  iconEnvelope,
  iconEnvelopeOpen,
  iconEnvelopeOpenSolid,
  iconEnvelopeSolid,
  iconEye,
  iconEyeSlash,
  iconEyeSolid,
  iconFile,
  iconFileArrowUp,
  iconFileArrowUpSolid,
  iconFileCsv,
  iconFileExport,
  iconFileLines,
  iconFileLinesSolid,
  iconFileSolid,
  iconFileSpreadsheet,
  iconFilter,
  iconFilterSolid,
  iconFingerprint,
  iconFloppyDisk,
  iconFloppyDiskSolid,
  iconFolder,
  iconFolderOpen,
  iconFolderOpenSolid,
  iconFolderPlus,
  iconFolderSolid,
  iconGear,
  iconGearSolid,
  iconGift,
  iconGiftSolid,
  iconGlobe,
  iconGlobeSolid,
  iconGrid2,
  iconGrid2Solid,
  iconGripVertical,
  iconHandshake,
  iconHashtag,
  iconHospital,
  iconHouse,
  iconHouseSolid,
  iconInboxSolid,
  iconHouseUser,
  iconIdCard,
  iconIdCardSolid,
  iconInbox,
  iconIndustry,
  iconKey,
  iconKeySolid,
  iconKeyboard,
  iconKeyboardSolid,
  iconLanguage,
  iconLayerGroup,
  iconLayerGroupSolid,
  iconLightbulb,
  iconLightbulbSolid,
  iconLink,
  iconLinkSolid,
  iconLinkedin,
  iconList,
  iconListCheck,
  iconListCheckSolid,
  iconListSolid,
  iconListUl,
  iconListUlSolid,
  iconLocationDot,
  iconLocationDotSolid,
  iconLock,
  iconLockSolid,
  iconMagnifyingGlass,
  iconMagnifyingGlassChart,
  iconMagnifyingGlassChartSolid,
  iconMagnifyingGlassSolid,
  iconMedal,
  iconMessage,
  iconMessageDots,
  iconMessageDotsSolid,
  iconMessageSolid,
  iconMinus,
  iconMobileScreenButton,
  iconMobileScreenButtonSolid,
  iconMoon,
  iconMoonSolid,
  iconPaperPlane,
  iconPaperPlaneClu,
  iconPaperPlaneCluSolid,
  iconPaperPlaneTop,
  iconPaperPlaneTopSolid,
  iconPaperclip,
  iconPartyHorn,
  iconPartyHornSolid,
  iconPause,
  iconPauseSolid,
  iconPencil,
  iconPencilSolid,
  iconPhone,
  iconPhoneSolid,
  iconPhoneVolume,
  iconPhoneVolumeSolid,
  iconPlay,
  iconPlaySolid,
  iconPlug,
  iconPlugCircleXmark,
  iconPlus,
  iconPlusSolid,
  iconPresentationScreen,
  iconPresentationScreenSolid,
  iconPuzzlePiece,
  iconPuzzlePieceSolid,
  iconQuestion,
  iconQuoteLeft,
  iconQuoteLeftSolid,
  iconRightFromBracket,
  iconRightFromBracketSolid,
  iconRobot,
  iconRobotSolid,
  iconRocket,
  iconSackDollar,
  iconSchool,
  iconSchoolSolid,
  iconSeedling,
  iconShareNodes,
  iconShieldCheck,
  iconShieldCheckSolid,
  iconShieldExclamation,
  iconShieldHalved,
  iconSidebar,
  iconSidebarSolid,
  iconSignalStream,
  iconSitemap,
  iconSitemapSolid,
  iconSliders,
  iconSlidersSolid,
  iconSparkles,
  iconSparklesSolid,
  iconSpinnerThird,
  iconSquare,
  iconSquareCheck,
  iconSquareCheckSolid,
  iconSquareSolid,
  iconStar,
  iconStarSolid,
  iconStop,
  iconStopSolid,
  iconStopwatch,
  iconStore,
  iconSun,
  iconSunSolid,
  iconT,
  iconTable,
  iconTableColumns,
  iconTableSolid,
  iconTag,
  iconTagSolid,
  iconThumbsDown,
  iconThumbsDownSolid,
  iconThumbsUp,
  iconThumbsUpSolid,
  iconThumbtack,
  iconThumbtackSlash,
  iconThumbtackSolid,
  iconTicket,
  iconTicketSolid,
  iconToggleOn,
  iconToggleOnSolid,
  iconTrash,
  iconTrashSolid,
  iconTriangleExclamation,
  iconTriangleExclamationSolid,
  iconUpRightAndDownLeftFromCenter,
  iconUpload,
  iconUser,
  iconUserCheck,
  iconUserGear,
  iconUserGroup,
  iconUserMagnifyingGlass,
  iconUserMagnifyingGlassSolid,
  iconUserMinus,
  iconUserPlus,
  iconUserSlash,
  iconUserSolid,
  iconUsers,
  iconUsersSolid,
  iconWallet,
  iconWandMagicSparkles,
  iconWarehouse,
  iconWavePulse,
  iconWebhook,
  iconWindowRestore,
  iconWindowRestoreSolid,
  iconXTwitter,
  iconXmark,
  iconXmarkSolid,
  iconChartUser,
  iconChartUserSolid,
  iconLightbulbSlash,
} from '@/lib/icons';
import type { AppIconProps } from '@/components/ui/app-icon';
import { useSyncExternalStore, type CSSProperties } from 'react';

// ---------------------------------------------------------------------------
// Dark-mode detection
//
// DynamicIcon renders solid (filled) glyphs in dark mode for weight='solid'
// (see below). We read the `dark` class off <html> — which the theme feature
// toggles — instead of the Redux theme selector, so this stays a self-contained
// primitive that works anywhere (isolated tests, portals) without a <Provider>.
// A single shared MutationObserver drives all instances.
// ---------------------------------------------------------------------------
const darkListeners = new Set<() => void>();
let isDarkSnapshot =
  typeof document !== 'undefined' &&
  document.documentElement.classList.contains('dark');

if (typeof document !== 'undefined') {
  new MutationObserver(() => {
    const next = document.documentElement.classList.contains('dark');
    if (next !== isDarkSnapshot) {
      isDarkSnapshot = next;
      darkListeners.forEach((l) => l());
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

function useIsDark(): boolean {
  return useSyncExternalStore(
    (cb) => {
      darkListeners.add(cb);
      return () => darkListeners.delete(cb);
    },
    () => isDarkSnapshot,
    () => false
  );
}

/**
 * DynamicIcon: runtime icon name -> the app's icon set (@/lib/icons).
 *
 * Static call sites import icon definitions from @/lib/icons and render them
 * with <AppIcon />; the sites that pick an icon at runtime (name/weight from
 * data or props) route here. Names are the kebab keys the app already uses
 * (the Font Awesome names the set replaced). Icons render in the regular
 * weight by default. `weight === 'fill'` always renders the solid variant;
 * `weight === 'solid'` is theme-adaptive — solid in dark mode, outline in light
 * — which is how the app fills nav/menu icons in dark mode (see the weight note
 * in the component body). Unknown names fall back to a question mark.
 */
const ICON_MAP: Record<string, IconDefinition> = {
  'address-card': iconIdCard,
  'align-left': iconAlignLeft,
  'address-book': iconAddressBook,
  'arrow-down': iconArrowDown,
  'arrow-down-a-z': iconArrowDownAZ,
  'arrow-down-to-bracket': iconDownload,
  'arrow-down-to-line': iconDownload,
  'arrow-left': iconArrowLeft,
  'arrow-left-from-line': iconArrowLeftFromLine,
  'arrow-right': iconArrowRight,
  'arrow-right-from-bracket': iconRightFromBracket,
  'arrow-right-from-line': iconArrowRightFromLine,
  'arrow-trend-up': iconArrowTrendUp,
  'arrow-up': iconArrowUp,
  'arrow-up-from-bracket': iconFileExport,
  'arrow-up-right': iconArrowUpRight,
  'arrow-up-right-from-square': iconArrowUpRightFromSquare,
  'arrow-up-z-a': iconArrowUpZA,
  'arrows-rotate': iconArrowsRotate,
  at: iconAt,
  award: iconMedal,
  'badge-check': iconBadgeCheck,
  'bag-shopping': iconBagShopping,
  ban: iconBan,
  bars: iconList,
  bell: iconBell,
  'bell-slash': iconBellSlash,
  binary: iconBinary,
  bolt: iconBolt,
  bookmark: iconBookmark,
  box: iconBox,
  briefcase: iconBriefcase,
  browser: iconBrowser,
  building: iconBuilding,
  'building-columns': iconBuildingColumns,
  buildings: iconBuildings,
  bullseye: iconBullseye,
  'bullseye-arrow': iconBullseyeArrow,
  calendar: iconCalendar,
  'calendar-check': iconCalendarCheck,
  'calendar-days': iconCalendarDays,
  book: iconBook,
  'book-open-lines': iconBookOpenLines,
  'caret-down': iconChevronDown,
  'chart-bar': iconChartBar,
  'chart-line': iconChartLine,
  'chart-line-up': iconChartLineUp,
  'chart-user': iconChartUser,
  'chart-simple': iconChartSimple,
  check: iconCheck,
  'chess-rook': iconChessRook,
  'chevron-down': iconChevronDown,
  'chevron-left': iconChevronLeft,
  'chevron-right': iconChevronRight,
  'chevron-up': iconChevronUp,
  'chevrons-left': iconChevronsLeft,
  'chevrons-right': iconChevronsRight,
  chrome: iconChrome,
  church: iconChurch,
  circle: iconCircle,
  'circle-arrow-up': iconCircleArrowUp,
  'circle-check': iconCircleCheck,
  'circle-chevron-down': iconCircleChevronDown,
  'circle-exclamation': iconCircleExclamation,
  'circle-info': iconCircleInfo,
  'circle-pause': iconPause,
  'circle-question': iconCircleQuestion,
  'circle-xmark': iconCircleXmark,
  'clipboard-check': iconClipboardList,
  'clipboard-list': iconClipboardList,
  clock: iconClock,
  'clock-rotate-left': iconClockRotateLeft,
  'cloud-arrow-up': iconCloudArrowUp,
  code: iconCode,
  'code-branch': iconCodeBranch,
  coin: iconCoin,
  coins: iconCoins,
  command: iconCommand,
  copy: iconCopy,
  'credit-card': iconCreditCard,
  cubes: iconCube,
  database: iconDatabase,
  desktop: iconDesktop,
  'diagram-project': iconSitemap,
  'dollar-sign': iconDollarSign,
  'down-left-and-up-right-to-center': iconDownLeftAndUpRightToCenter,
  'down-to-line': iconDownToLine,
  download: iconDownload,
  'earth-americas': iconGlobe,
  ellipsis: iconEllipsis,
  'ellipsis-vertical': iconEllipsisVertical,
  envelope: iconEnvelope,
  'envelope-circle-check': iconCircleCheck,
  'envelope-circle-xmark': iconCircleXmark,
  'envelope-open': iconEnvelopeOpen,
  'envelope-open-text': iconEnvelopeOpen,
  eye: iconEye,
  'eye-slash': iconEyeSlash,
  'file-arrow-up': iconFileArrowUp,
  'file-csv': iconFileCsv,
  'file-lines': iconFileLines,
  'file-question': iconFile,
  'file-spreadsheet': iconFileSpreadsheet,
  filter: iconFilter,
  'filter-circle-check': iconFilter,
  fingerprint: iconFingerprint,
  'floppy-disk': iconFloppyDisk,
  folder: iconFolder,
  'folder-open': iconFolderOpen,
  'folder-plus': iconFolderPlus,
  gear: iconGear,
  gift: iconGift,
  globe: iconGlobe,
  'graduation-cap': iconSchool,
  'grid-2': iconGrid2,
  'grip-dots-vertical': iconGripVertical,
  'grip-vertical': iconGripVertical,
  handshake: iconHandshake,
  hashtag: iconHashtag,
  hospital: iconHospital,
  hotel: iconBed,
  house: iconHouse,
  'house-blank': iconGrid2,
  'id-card': iconIdCard,
  'identification-card': iconIdCard,
  inbox: iconInbox,
  industry: iconIndustry,
  key: iconKey,
  keyboard: iconKeyboard,
  landmark: iconBuildingColumns,
  language: iconLanguage,
  'layer-group': iconLayerGroup,
  lightbulb: iconLightbulb,
  link: iconLink,
  'link-simple': iconLink,
  linkedin: iconLinkedin,
  list: iconList,
  'list-check': iconListCheck,
  'list-ul': iconListUl,
  'location-dot': iconLocationDot,
  lock: iconLock,
  'magnifying-glass': iconMagnifyingGlass,
  'magnifying-glass-chart': iconMagnifyingGlassChart,
  message: iconMessage,
  'message-plus': iconMessageDots,
  minus: iconMinus,
  'mobile-screen-button': iconMobileScreenButton,
  moon: iconMoon,
  output: iconFileExport,
  'paper-plane-top': iconPaperPlaneTop,
  'paper-plane-clu': iconPaperPlaneClu,
  'house-user': iconHouseUser,
  'paper-plane': iconPaperPlane,
  paperclip: iconPaperclip,
  'party-horn': iconPartyHorn,
  pause: iconPause,
  'pen-line': iconPencil,
  'pen-to-square': iconPencil,
  pencil: iconPencil,
  phone: iconPhone,
  'phone-volume': iconPhoneVolume,
  play: iconPlay,
  plug: iconPlug,
  'plug-circle-xmark': iconPlugCircleXmark,
  plus: iconPlus,
  'presentation-chart': iconPresentationScreen,
  'puzzle-piece': iconPuzzlePiece,
  'quote-left': iconQuoteLeft,
  'right-from-bracket': iconRightFromBracket,
  'right-left': iconArrowsLeftRight,
  robot: iconRobot,
  rocket: iconRocket,
  'sack-dollar': iconSackDollar,
  school: iconSchool,
  seedling: iconSeedling,
  'share-nodes': iconShareNodes,
  'shield-check': iconShieldCheck,
  'shield-exclamation': iconShieldExclamation,
  'shield-halved': iconShieldHalved,
  sidebar: iconSidebar,
  'sidebar-flip': iconSidebar,
  'signal-stream': iconSignalStream,
  sliders: iconSliders,
  sort: iconArrowDownArrowUp,
  sparkles: iconSparkles,
  spinner: iconSpinnerThird,
  'spinner-third': iconSpinnerThird,
  square: iconSquare,
  'square-check': iconSquareCheck,
  'square-pen': iconPencil,
  'square-question': iconQuestion,
  'square-virus': iconKey,
  star: iconStar,
  stars: iconSparkles,
  stop: iconStop,
  stopwatch: iconStopwatch,
  store: iconStore,
  sun: iconSun,
  t: iconT,
  table: iconTable,
  'table-columns': iconTableColumns,
  'table-list': iconTable,
  tag: iconTag,
  tags: iconTag,
  text: iconT,
  'thumbs-down': iconThumbsDown,
  'thumbs-up': iconThumbsUp,
  thumbtack: iconThumbtack,
  'thumbtack-slash': iconThumbtackSlash,
  ticket: iconTicket,
  'toggle-on': iconToggleOn,
  trash: iconTrash,
  'triangle-exclamation': iconTriangleExclamation,
  twitter: iconXTwitter,
  'up-right-and-down-left-from-center': iconUpRightAndDownLeftFromCenter,
  upload: iconUpload,
  user: iconUser,
  'user-circle-plus': iconUserPlus,
  'user-check': iconUserCheck,
  'user-gear': iconUserGear,
  'user-group': iconUserGroup,
  'user-list': iconUsers,
  'user-magnifying-glass': iconUserMagnifyingGlass,
  'list-bullets': iconList,
  'user-minus': iconUserMinus,
  'user-plus': iconUserPlus,
  'user-slash': iconUserSlash,
  users: iconUsers,
  wallet: iconWallet,
  'wand-magic-sparkles': iconWandMagicSparkles,
  'wand-sparkles': iconWandMagicSparkles,
  warehouse: iconWarehouse,
  'wave-pulse': iconWavePulse,
  webhook: iconWebhook,
  'window-restore': iconWindowRestore,
  x: iconXmark,
  xmark: iconXmark,
  'lightbulb-slash': iconLightbulbSlash,
};

/** Solid variants — used only when weight === 'fill' and a variant exists. */
const FILLED_MAP: Record<string, IconDefinition> = {
  'address-card': iconIdCardSolid,
  'arrow-down-to-bracket': iconDownloadSolid,
  'arrow-down-to-line': iconDownloadSolid,
  'arrow-up-right-from-square': iconArrowUpRightFromSquareSolid,
  'badge-check': iconBadgeCheckSolid,
  bars: iconListSolid,
  bell: iconBellSolid,
  bolt: iconBoltSolid,
  bookmark: iconBookmarkSolid,
  briefcase: iconBriefcaseSolid,
  calendar: iconCalendarSolid,
  book: iconBookSolid,
  'book-open-lines': iconBookOpenLinesSolid,
  'caret-down': iconChevronDownSolid,
  'chart-line': iconChartLineSolid,
  'chart-line-up': iconChartLineUpSolid,
  'chart-user': iconChartUserSolid,
  check: iconCheckSolid,
  'chevron-down': iconChevronDownSolid,
  'chevron-right': iconChevronRightSolid,
  circle: iconCircleSolid,
  'circle-arrow-up': iconCircleArrowUpSolid,
  'circle-check': iconCircleCheckSolid,
  'circle-question': iconCircleQuestionSolid,
  'circle-chevron-down': iconCircleChevronDownSolid,
  'circle-exclamation': iconCircleExclamationSolid,
  'circle-info': iconCircleInfoSolid,
  'circle-pause': iconPauseSolid,
  'circle-xmark': iconCircleXmarkSolid,
  'clipboard-check': iconClipboardListSolid,
  'clipboard-list': iconClipboardListSolid,
  clock: iconClockSolid,
  code: iconCodeSolid,
  coin: iconCoinSolid,
  copy: iconCopySolid,
  'credit-card': iconCreditCardSolid,
  database: iconDatabaseSolid,
  desktop: iconDesktopSolid,
  'diagram-project': iconSitemapSolid,
  download: iconDownloadSolid,
  'earth-americas': iconGlobeSolid,
  ellipsis: iconEllipsisSolid,
  'ellipsis-vertical': iconEllipsisVerticalSolid,
  envelope: iconEnvelopeSolid,
  'envelope-circle-check': iconCircleCheckSolid,
  'envelope-circle-xmark': iconCircleXmarkSolid,
  'envelope-open': iconEnvelopeOpenSolid,
  'envelope-open-text': iconEnvelopeOpenSolid,
  eye: iconEyeSolid,
  'file-arrow-up': iconFileArrowUpSolid,
  'file-lines': iconFileLinesSolid,
  'file-question': iconFileSolid,
  filter: iconFilterSolid,
  'filter-circle-check': iconFilterSolid,
  'floppy-disk': iconFloppyDiskSolid,
  folder: iconFolderSolid,
  'folder-open': iconFolderOpenSolid,
  gear: iconGearSolid,
  gift: iconGiftSolid,
  globe: iconGlobeSolid,
  'graduation-cap': iconSchoolSolid,
  'grid-2': iconGrid2Solid,
  hotel: iconBedSolid,
  house: iconHouseSolid,
  inbox: iconInboxSolid,
  'house-user': iconHouseUser,
  'house-blank': iconGrid2Solid,
  'address-book': iconAddressBookSolid,
  browser: iconBrowserSolid,
  building: iconBuildingSolid,
  buildings: iconBuildingsSolid,
  robot: iconRobotSolid,
  'user-magnifying-glass': iconUserMagnifyingGlassSolid,
  'id-card': iconIdCardSolid,
  'identification-card': iconIdCardSolid,
  key: iconKeySolid,
  keyboard: iconKeyboardSolid,
  'layer-group': iconLayerGroupSolid,
  lightbulb: iconLightbulbSolid,
  link: iconLinkSolid,
  'link-simple': iconLinkSolid,
  linkedin: iconLinkedin,
  list: iconListSolid,
  'list-check': iconListCheckSolid,
  'list-ul': iconListUlSolid,
  'location-dot': iconLocationDotSolid,
  lock: iconLockSolid,
  'magnifying-glass': iconMagnifyingGlassSolid,
  'magnifying-glass-chart': iconMagnifyingGlassChartSolid,
  message: iconMessageSolid,
  'message-plus': iconMessageDotsSolid,
  'mobile-screen-button': iconMobileScreenButtonSolid,
  moon: iconMoonSolid,
  'paper-plane-top': iconPaperPlaneTopSolid,
  'paper-plane-clu': iconPaperPlaneCluSolid,
  'party-horn': iconPartyHornSolid,
  pause: iconPauseSolid,
  'pen-line': iconPencilSolid,
  'pen-to-square': iconPencilSolid,
  pencil: iconPencilSolid,
  phone: iconPhoneSolid,
  'phone-volume': iconPhoneVolumeSolid,
  play: iconPlaySolid,
  plus: iconPlusSolid,
  'presentation-chart': iconPresentationScreenSolid,
  'puzzle-piece': iconPuzzlePieceSolid,
  'quote-left': iconQuoteLeftSolid,
  school: iconSchoolSolid,
  'shield-check': iconShieldCheckSolid,
  sidebar: iconSidebarSolid,
  'sidebar-flip': iconSidebarSolid,
  sliders: iconSlidersSolid,
  sparkles: iconSparklesSolid,
  square: iconSquareSolid,
  'square-check': iconSquareCheckSolid,
  'square-pen': iconPencilSolid,
  'square-virus': iconKeySolid,
  star: iconStarSolid,
  stars: iconSparklesSolid,
  stop: iconStopSolid,
  sun: iconSunSolid,
  table: iconTableSolid,
  'table-list': iconTableSolid,
  tag: iconTagSolid,
  tags: iconTagSolid,
  'thumbs-down': iconThumbsDownSolid,
  'thumbs-up': iconThumbsUpSolid,
  thumbtack: iconThumbtackSolid,
  ticket: iconTicketSolid,
  'toggle-on': iconToggleOnSolid,
  trash: iconTrashSolid,
  'triangle-exclamation': iconTriangleExclamationSolid,
  twitter: iconXTwitter,
  user: iconUserSolid,
  users: iconUsersSolid,
  'right-from-bracket': iconRightFromBracketSolid,
  'arrow-right-from-bracket': iconRightFromBracketSolid,
  'list-bullets': iconListSolid,
  'window-restore': iconWindowRestoreSolid,
  x: iconXmarkSolid,
  xmark: iconXmarkSolid,
  'lightbulb-slash': iconLightbulbSlash,
};

export interface DynamicIconProps {
  /** Icon name (kebab-case). */
  name: string;
  /** Legacy weight; only 'fill' is honoured (-> solid variant). */
  weight?: string;
  /** Optional tooltip / accessible label. */
  title?: string;
  /** The candy drawing to use, where it means more than the icon's name. */
  candy?: string;
  /** Pixel size (maps to font-size on the rendered SVG). */
  size?: number | string;
  className?: string;
  style?: CSSProperties;
  color?: string;
}

export function DynamicIcon({
  name,
  weight,
  title,
  size,
  style,
  ...rest
}: DynamicIconProps) {
  const isDark = useIsDark();
  // Weight resolution:
  //   'fill'  -> always solid (theme-independent, e.g. a favourited star).
  //   'solid' -> theme-adaptive: solid in dark mode, outline in light. The app
  //              passes weight='solid' for active/hover and dark-mode states and
  //              expects them to fill only in dark mode.
  //   else    -> regular outline.
  const useSolid = weight === 'fill' || (weight === 'solid' && isDark);
  const icon = (useSolid && FILLED_MAP[name]) || ICON_MAP[name] || iconQuestion;
  const mergedStyle = (
    size != null ? { fontSize: size, ...style } : style
  ) as AppIconProps['style'];
  return <AppIcon icon={icon} title={title} style={mergedStyle} {...rest} />;
}
